export const SUB = 1_000_000;

/** Exact integer -> string. No floats, ever. */
export const fmtAxv = (sub, places = 6) => {
  const n = Math.trunc(sub || 0);
  const sign = n < 0 ? "-" : "";
  const a = Math.abs(n);
  const whole = Math.floor(a / SUB);
  const frac = String(a % SUB).padStart(6, "0").slice(0, places);
  return places === 0 ? `${sign}${whole}` : `${sign}${whole}.${frac}`;
};

/** Trims trailing zeros but keeps at least 2 dp — for HUD readability. */
export const fmtAxvTrim = (sub) => {
  const s = fmtAxv(sub);
  const [w, f] = s.split(".");
  const trimmed = f.replace(/0+$/, "");
  return `${w}.${(trimmed.length < 2 ? trimmed.padEnd(2, "0") : trimmed)}`;
};

export const axvToSub = (axv) => Math.trunc(Number(axv) * SUB);

export const IMAGES = {
  arcade:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/1ee6e2b696672f1bc477b0fcbfd28af8b544b9682c75f50a6e6eee65d16083c6.jpeg",
  cove:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/d678a74f1e9f3265c8e2f64cc7f33025be0063aca9c82e268eb11931ce601f39.jpeg",
  // The Coat Closet — the way into the Green Room, in Clarity Hall. Named
  // "mudRoom" until 31 Aug 2026; "Mud Room" is now RESERVED for the Vault and
  // must not be reused here. See memory/PRD.md taxonomy.
  coatCloset:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/2fd99060aeef68780671ca5f02294b6b97bb6d9db13844e02797eac44e78ab73.jpeg",
  foyer:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/573a204d8f9ebfc120ce82388439d8743ea67884769cf9afd818e60e2af55408.jpeg",
  melzai:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/2632cc234361a9fbe25f0e26ac4a5ab5cd1432bf61188ea2043d24c0509e6699.jpeg",
  // Founder-supplied, text-free 4K island render — the canonical World map.
  atlasIslands:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/03ky9fc9_3D47EF58-A419-405D-ADE5-99A5AAF85385.png",
  // Ghost World V1 — 16:9 aerial of the eight-island World, seven islands
  // rendered as translucent "ghost" structures and one (the Commons, warm
  // wooden tavern with fire pit) fully realized. Used as the endeavorum.com
  // above-the-fold hero: reads as "here's what we're building; come to the
  // one that's already lit." Explicit "no bridges to ghost islands" is a
  // Myst-protocol design rule — sealed Places are LOOKED at, not walked to.
  ghostWorld:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/u4jfh0qs_Endeavorum_Ghost_World_16x9_True4K_3840x2160%201.webp",
  // Commons Teleport Pad — the arrival view for endeavorum.org. Founder-final
  // render (12 Feb 2026): tavern-with-compass-rose ground-level, warm sunset
  // over a floating patio, fire pit at centre, waterfall edge, ghosted
  // mountain vista in the distance. Cracked-stone compass rose in the near
  // foreground IS the Teleport Pad — arrivals materialise on it.
  commonsPad:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/ae85byv9_00FB7821-1181-4DD9-8D76-CF1130286395.png",
  // Second patio position — the founder's confirmed "you've arrived" state.
  // Camera drops closer to the fire pit: chairs pulled up, tavern glowing in
  // the background, mountains at dawn/sunset. This is where the visitor stands
  // AFTER stepping onto the Pad. Used for /commons landing (13 Feb 2026).
  commonsFirepit:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/g8d9lcs3_E2AAAAC2-5A3F-4B54-90E0-ACE646CCFA82.png",
  pfGlassDoors:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/450c3c3ecf6a30ec6104febf4e379c4d840a2ea70fa2075db1c607e65885f82c.jpeg",
  // Founder-supplied Arcade lounge — quotes on the wall, cabinet row, Chesterfield.
  // This is the END STATE: where the cut PlayCard is presented and anted.
  pfLounge:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/a6f416fn_3100E533-30F6-40E3-BEB0-F64AB3ABE89E.jpeg",
  // Founder's seated Cove plate. Screen rect measured, see lib/beats.js.
  // Sliced from the founder's Gibidy contact sheet, served locally. LOW RES
  // (~763px source) — swap for individual full-res renders when they land.
  pfArcadeEnter: "/plates/pf_arcade_enter.webp",
  pfLookLeft: "/plates/pf_arcade_look_left.webp",
  pfLookRight: "/plates/pf_arcade_look_right.webp",
  pfDeeper: "/plates/pf_arcade_deeper.webp",
  pfCoveLook: "/plates/pf_cove_look.webp",
  pfCoveSeat:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/c2kn9ain_3F6AB0B8-FF07-42F9-953B-4A03A1994936.png",
  pfCove:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/hlm0quil_IMG_6428.webp",
  // Founder brand lockups. Dark-field version for dark rooms, light for the Atlas.
  pfArcadeApproach:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/gfqbtu93_E8C2CD40-239A-4390-B394-55B1F1E4E0D0.png",
  pfStepForward:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/f8e6217777e7e936e74e992173ed177a975448e4bc78a512c39907fff9ccba68.jpeg",
  // --------------------------------------------------------- Stageward
  // Clarity Hall. Renaissance becomes baroque: the register changes on purpose
  // when you cross the Seam. Founder-supplied, four beats.
  swHallApproach:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/3axbph5z_191A7EF8-401E-4F1A-9F3E-DEE08AB1E8EA.png",
  swFoyer:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/5cg9o1ly_CF01D12B-E233-4AB6-BA87-D36B30D6A3EB.png",
  swGreenRoomDoor:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/i8pre1s4_77FF5935-34D8-419A-A1E7-7751C7562EDD.png",
  // The blank wall. Every Shard is live HTML scrawled inside this panel.
  swGraffitiWall:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/i2js3hte_BDA3BBCB-6A31-409D-A571-E0157841C562.png",
  // Coat on the hook, and a door out of the closet.
  swGreenRoomExit:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/m898ctg5_0D14866C-D33C-468E-BB48-0BC1054A8FAB.png",
  // The Drawing Room, and the Drawing Table in three moves.
  swDrawingRoom:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/36xwdbmu_34E6DE99-0911-41EC-8071-39B10EDEF2F5.png",
  swTableApproach:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/vncbtnk7_ACCF8ECF-FCEE-42EB-BE43-8424ACBA127F.png",
  swTableFront:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/2aal94y2_7B891A68-B987-47CD-93B8-980BAD20E9E9.png",
  // Blank vellum, full frame. Stacks and Clusters are laid out ON this.
  swDrawingSurface:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/5pz5ou3k_96BF4026-9C47-4D22-B3F8-9F3AA1F0943F.png",
  // --------------------------------------------------- the Design Desk
  // Next after the Drawing Table. The Table is where the work gets ordered;
  // the Desk is where the order gets a date. The monitor is genuinely blank —
  // the Horizon Map is live HTML inside its bezel.
  swDeskRoom:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/e7b0cyng_IMG_6641.webp",
  swDeskFront:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/hll0dq2e_1A11F0A6-FAD9-4EDD-B1E8-A5D1E5305CB9.png",
  swDeskSeated:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/l6klbb36_B9648C14-387B-40C9-A38A-1DE8EF195A58.png",
  swDeskLamp:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/5nito6iv_260E336F-1F48-4235-8CD4-5E558464E325.png",
  swDeskClose:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/qqsswbay_E84446FB-99C1-4E10-B16A-25F0667AAAD1.jpeg",
  // THE SCREEN. Blank, straight on. The Horizon Map lives in here.
  swDeskScreen:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/x3fpqhnw_1D0612FA-28B2-4649-9BB3-D0F5D111C3A1.png",
  // ------------------------------------------------------- the Sofa wall
  // Division of labour, founder's: the monitor is where MelzAI BUILDS the Map,
  // the wall screen is where you MONITOR progress against it. Same room as the
  // Drawing Table — the lectern is visible at the right of swSofaRoom.
  swSofaRoom:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/6en2ba05_DDDEBE9D-F50B-4D73-AA9F-2CEA3B93FA73.png",
  // Blank wall screen, straight on. Progress is live HTML inside the bezel.
  swSofaScreen:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/ep77izq7_53B9BD6D-0637-4492-81C9-9B6AEE47B48A.png",
  // ------------------------------------------------- Place exteriors
  // The monorail stops. Exteriors ONLY — founder's rule: they get teased with a
  // shot, but they have to go in themselves. Two Places are open today; the
  // rest are honest about being closed, which makes the World feel larger than
  // the build rather than smaller.
  exArena:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/t5oe03t3_E9CAA595-5314-4A46-9F52-903B8A96EBA6.webp",
  // Renamed 14 Feb 2026: exStudio → exOps. Same exterior render; the Place
  // at 2 o'clock is now "Ops" and the broadcast Studio is a Space inside it.
  exOps:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/2lsrx6mc_670A73BA-E09E-416D-B3F2-C5189623864D.png",
  exChamber:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/iddx4je4_55F97113-A801-4B56-A188-F371C6457AB9.png",
  exBridge:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/as3xootq_DCBD6B31-91A6-4A9F-AF2C-62F0E3F75372.png",
  exCommons:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/hf0zkiel_0B019729-CB61-4496-8383-94ABEDFF6AB3.webp",
  // Riveted bronze, keypad, gears — the plaque reads ARCHIVE · RECORD ·
  // REFLECT · EVOLVE. Eight of eight.
  exVault:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/8wvu7a9i_DC483805-10AF-4378-9A77-0585D1729DA5.png",
  // exVault — landed 30 Jun 2026. The monorail skips any Place with no plate.
  // black-field lockup -> use over dark rooms with mix-blend-mode: screen
  logoDark:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/8bt9xo0d_D76FA9AB-D4A1-4FE9-8A05-84F3312D911A.jpeg",
  // white-field lockup -> use over the bright Atlas with mix-blend-mode: multiply
  logoLight:
    "https://customer-assets-jt897jd0.emergentagent.net/job_melzai-world/artifacts/onuevfhw_D76FA9AB-D4A1-4FE9-8A05-84F3312D911A.jpeg",
  // transparent-field emblem, for laying flat on the hub plaza
  emblem:
    "https://static.prod-images.emergentagent.com/jobs/f5448faa-82a3-443d-803d-77b606c060d0/images/c509055829e5a2fce8f2bf1f7a518ac776900f800b6151ccc9586bc981b93208.jpeg",
};

/**
 * MelzAI as a standing presence, one plate per mode. Keyed off the founder's
 * Francesco Melzi persona sheets: same figure, same lens, expression only.
 * Alpha-cut WebP, bottom-anchored, so he stands in the room rather than
 * floating in a card. Swap any one file and nothing else changes.
 */
export const MELZ_FIGURES = {
  Clarify: "/melz/melz_clarify.webp",
  Explore: "/melz/melz_explore.webp",
  Challenge: "/melz/melz_challenge.webp",
  Refine: "/melz/melz_refine.webp",
  Plan: "/melz/melz_plan.webp",
};

export const BRAND = {
  gold: "#c9a227",
  goldLight: "#e8ce7a",
  goldDeep: "#8a6a1e",
  oxblood: "#6e1f22",
  oxbloodDeep: "#3a1010",
  ink: "#0b0704",
};
